import { supabase } from '../api/supabase'

export interface CustomerLite {
  id: string
  code: string
  name: string
}

// Z88: server-side customer lookup for pickers -- never loads the table. `role` filters through
// the customer_address_types junction in ONE query (inner join), instead of fetching every id with
// that role and pasting them into an .in() list (URL length blows up past a few hundred ids).
export async function searchCustomers(opts: { role?: string; term?: string; limit?: number }): Promise<CustomerLite[]> {
  const { role, term = '', limit = 50 } = opts
  const select = role
    ? 'id, code, name, customer_address_types!inner(address_types!inner(code))'
    : 'id, code, name'
  let q = supabase.from('customers').select(select).eq('is_active', true)
  if (role) q = q.eq('customer_address_types.address_types.code', role)
  const t = term.trim().replace(/[%,()]/g, ' ')
  if (t) q = q.or(`name.ilike.%${t}%,code.ilike.${t}%`)
  const { data, error } = await q.order('name').order('id').limit(limit)
  if (error) throw new Error(error.message)
  return ((data ?? []) as unknown as CustomerLite[]).map(c => ({ id: c.id, code: c.code, name: c.name }))
}

export async function getCustomerLite(id: string): Promise<CustomerLite | null> {
  const { data } = await supabase.from('customers').select('id, code, name').eq('id', id).maybeSingle()
  return (data as CustomerLite | null) ?? null
}
